// Редирект на стор моб прилодений ГФ
export const APPMETRICA = 'https://redirect.appmetrica.yandex.com/serve/1108516733871780794'

// Политика перс данных, старый вариант если не заполнено vcp
export const CONSENT_TO_DATA_PROCESSING = 'https://growfood.pro/consent_to_data_processing.pdf?v=12.11'

export const TIMER_ON_CMZ = ['abyk']

// Показывать баннер акции на мобильных устройствах по CMZ
export const BANNER_ON_CMZ = ['1ZV7']

// раз в сколько дней происходит оплата подписки
export const SUBSCRIPTION_PRICE_DIVIDER = 6

export const CMZ_OLD_OFFERS = '8dzV'

export const CITY_SELECTOR_REMOVE_CMZ = ['KdMo', 'Yzgp']

export const DaySessions = {
  EVENING: 'evening',
  MORNING: 'morning',
}

export const Times = {
  SEVEN_AM: '07:00',
  SIX_PM: '18:00',
}

export const OrderOriginIds = {
  LANDING_AUTHORIZED: 12,
  LANDING_UNAUTHORIZED: 1,
}

export const BRAND_ID_H = 'lY'

export const CosmeticDiscount = {
  2: 20,
  6: 25,
  12: 30,
  24: 35,
  27: 35,
  30: 35,
  60: 40,
}

// было принято решение выводить кэшбэк если он больше 50%, что бы не перегржать интерфейс
export const CAHBACK_VISIBLE_THRESHOLD = 50

export const WELCOME_SET = 'welcome-set'
export const WELCOME_SET_PATH = '/new-order/welcome-set'

export const WelcomeSetInfo = {
  TYPE: WELCOME_SET,
  IMG: require('@/assets/images/tariffs/welcome.png'),
  TITLE: 'Пробное меню',
  DESCRIPTION: `
    <p>
      Набор еды на&nbsp;2&nbsp;дня из нашего самого популярного меню
    </p>
    <p>
      Отлично подойдёт для тех, кто хочет попробовать формат питания c&nbsp;GrowFood
    </p>
  `,
}

export const ECONOM_START_NAMES = 'econom'

export const EconomSetInfo = {
  TYPE: 'economy',
  IMG: require('@/assets/images/tariffs/save.png'),
  TITLE: 'Эконом меню',
  DESCRIPTION: `
    <ul>
      <li>
        Фиксированное меню
      </li>
      <li>
        Три варианта питания по&nbsp;калориям
      </li>
      <li>
        Доставка каждые&nbsp;3&nbsp;дня
      </li>
    </ul>
  `,
  enabledBy: ['econom_1000', 'econom_1500', 'econom_2000'],
  imageUrl: require('@/assets/images/tariffs/desktop/save.png'),
  line3: 'фиксированное меню<br/> и доставка утром кажые 3 дня',
  promoMark: 'АКЦИЯ',
  promoMarkColor: '#ff3232',
  subtitle: 'от 655 ₽/день',
  title: 'Хочу недорого',
  type: 'economy',
}

export const PersonalSetInfo = {
  TYPE: 'personal',
  IMG: require('@/assets/images/tariffs/personal.png'),
  TITLE: 'Персональное меню',
  DESCRIPTION: `
    <ul>
      <li>
        Точный подбор питания по&nbsp;калориям
      </li>
      <li>
        Настройка предпочтений
      </li>
      <li>
        Гибкая замена блюд
      </li>
      <li>
        Доставка утром или вечером
      каждые 2&nbsp;дня
      </li>
      <li>
        Доставка к&nbsp;точному времени
      </li>
    </ul>
  `,
}

// view & goals codes for GoalsSelector & ViewsSelector
export const CALORIES = 'calories'
export const MEALS = 'meals'
export const HIGH = 'high'
export const MEDIUM = 'medium'

export const TargetAssociations = {
  LOW: {
    TARGET: 'p1',
    ID: 1,
  },
  MEDIUM: {
    TARGET: 'p2',
    ID: 2,
  },
  HIGH: {
    TARGET: 'p3',
    ID: 3,
  },
  ECONOMY: {
    TARGET: 'p5',
    ID: 5,
  },
}
